import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';

const CreateOrder = () => {
    return (
        <div>
            <Header />
            <section className="tf-contact tf-section">
                <div className="themesflat-container">
                    <div className="row">
                        <div className="col-12">
                            <div className="flat-form">
                                <h2 className="tf-title-heading ct style-2 mg-bt-12">
                                    Create Order
                                </h2>
                                <h5 className="sub-title ct style-1 pad-0-15">
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum obcaecati dignissimos quae quo ad iste ipsum officiis deleniti asperiores sit.
                                </h5>
                                <div className="form-inner">
                                    <form id="contactform" noValidate="novalidate" className="form-submit">
                                        <div className="row-form style-2">
                                            <select id="subject">
                                                <option value="0">Type</option>
                                                <option value="1">Order</option>
                                                <option value="2">Sell</option>
                                            </select>
                                            <i className="icon-fl-down"></i>
                                         </div>
                                        <input id="phone number" name="phone number" tabIndex="1" aria-required="true" required type="text" placeholder="Your Phone Number" />
                                        <textarea id="message" name="message" tabIndex="3" aria-required="true" required placeholder="Message"></textarea>
                                        <button className="submit">Create</button>
                                    </form>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}

export default CreateOrder;
